import { render, staticRenderFns } from "./ArchiveInventories.vue?vue&type=template&id=d21f4d6e&"
import script from "./ArchiveInventories.vue?vue&type=script&lang=js&"
export * from "./ArchiveInventories.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveInventories.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchiveInventories.vue"
export default component.exports